import { LegalPage } from "./LegalPage.jsx";

const DEMO_HTML = `
<p>
  This Privacy Policy explains how Shere-e-Punjab Homes Pty Ltd
  ("we", "us", "our") collects, uses, discloses and protects your personal
  information when you visit our website, request a quote, attend a display
  home, or engage us as your home builder.
</p>

<h2>What we collect</h2>
<p>
  We collect personal information that you voluntarily provide to us. This
  typically includes your name, email address, phone number, residential
  address, the suburb you're building in, your block details, and any
  preferences you share about your design or budget.
</p>
<p>
  When you visit our website we also collect technical information through
  cookies and analytics tools. That includes pages viewed, time on page, IP
  address, device and browser type, and referral source.
</p>

<h2>How we use your information</h2>
<ul>
  <li>To respond to your enquiries and prepare quotes or proposals.</li>
  <li>To progress a build contract — including coordinating with brokers, conveyancers, council bodies, and our own trades.</li>
  <li>To send you scheduled communications about your build (frame stage walk-through, pre-handover meeting, aftercare reviews).</li>
  <li>To provide warranty service during the statutory warranty period.</li>
  <li>To improve our website, marketing, and design pipeline (always on aggregated, non-identifying data).</li>
</ul>

<h2>How we share information</h2>
<p>
  We share your information only with parties who genuinely need it to
  deliver your build — for example, the engineers we engage to certify your
  slab, the council planning officer reviewing your permit, or the supplier
  drop-shipping your appliances. We do not sell, rent, or trade your
  personal information.
</p>

<h2>How we store information</h2>
<p>
  Your information is stored on Australian-hosted infrastructure with
  industry-standard encryption at rest and in transit. We retain build files
  for the duration of the statutory warranty period plus seven years for
  audit purposes.
</p>

<h2>Your rights</h2>
<p>
  You may request access to, or correction of, the personal information we
  hold about you at any time. You can also request that we delete your
  information after the warranty period ends. Email
  <a href="mailto:privacy@sherepunjabhomes.com.au">privacy@sherepunjabhomes.com.au</a>
  with your request and we'll respond within 14 days.
</p>

<h2>Cookies and tracking</h2>
<p>
  Our website uses Google Analytics, Meta Pixel, and Google Tag Manager when
  configured by an administrator. These tools may set cookies that track
  your interactions across our site. You can disable non-essential cookies
  in your browser settings without losing core functionality.
</p>

<h2>Contact us</h2>
<p>
  Questions about this policy? Reach out to our Privacy Officer at
  <a href="mailto:privacy@sherepunjabhomes.com.au">privacy@sherepunjabhomes.com.au</a>
  or by post at the address listed in our footer.
</p>

<p><em>This is a demo policy provided for development purposes. It is not legal advice — replace this content with a policy reviewed by your solicitor before going live.</em></p>
`;

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      field="privacyPolicy"
      title="Privacy Policy"
      description="How Shere-e-Punjab Homes collects, stores, and uses your personal information."
      demoHtml={DEMO_HTML}
    />
  );
}
